import {useState} from 'react'
import Carousel from "react-multi-carousel"
import "./carouselStyle.css"
import HotbuyTile from "../Components/HotbuyTile"
import CategortTile from "../Components/CategoryTile"
import CutpriceTile from "../Components/CutpriceTile"
import taggingHelper from '../helpers/taggingHelper'
import { useSwipeable } from 'react-swipeable'

const WhiteTilesSlier = ({
  productsInfo,
  bgImage,
  headerColor,
  showArrows,
  largeTile,
  autoplay,
  autoPlaySpeed,
  swipeable,
  sliderID,
}) => {
  const [ dragging , setDragging] = useState(false)
  const [ swipeDirection , setSwipeDirection] = useState()
  //console.log('productsInfo in silder:',productsInfo)
  const responsiveWhiteTile = {
    desktop: {
      breakpoint: { max: 3000, min: 992 },
      items: 4,
      slidesToSlide: 1,
    },
    tabletLandscape: {
      breakpoint: { max: 991, min: 768 },
      items: 3,
      slidesToSlide: 1,
    },
    tabletPortrait: {
      breakpoint: { max: 767, min: 250 },
      items: 1,
      slidesToSlide: 1,
    },
  }
  const CustomDot = ({ onClick, ...rest }) => {
  const {
    index,
    active
  } = rest;
  return (
    <button
      className={`react-multi-carousel-dot ${active ? 'react-multi-carousel-dot--active' : ''}`}
      onClick={() => {
        taggingHelper('Navigation dots',index,sliderID,'type1')
        onClick()
      } }>
    </button>  );
  };

  const CustomRightArrow = ({ onClick }) => (
    <button
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
      onClick={() => {
        taggingHelper('Arrow slider Right','',sliderID,'type2')
        onClick();
      }}
    />
  );
  const CustomLeftArrow = ({ onClick }) => (
    <button
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
      onClick={() => {
        taggingHelper('Arrow slider Left','',sliderID,'type2')
        onClick();
      }}
    />
  );
  let whiteTiles;
  {productsInfo && productsInfo !== undefined
      ? (whiteTiles = productsInfo.map((pInfo,i) => {
          //console.log('pInfo:',pInfo)
          switch (pInfo.type) {
            case "HotBuy":
              return (
                <HotbuyTile
                  info={pInfo}
                  key={pInfo.sku}
                  sku={pInfo.sku}
                  bgImage={bgImage}
                  headerColor={headerColor}
                  largeTile={largeTile}
                  swipeable={swipeable}
                  index={i}
                  sliderID={sliderID}
                  dragging={dragging}
                  swipeDirection={swipeDirection}
                  sliderLength = {productsInfo.length}
                />
              )
            case "CutPrice":
              return (
                <CutpriceTile
                  info={pInfo}
                  key={pInfo.sku}
                  sku={pInfo.sku}
                  bgImage={bgImage}
                  headerColor={headerColor}
                  largeTile={largeTile}
                  swipeable={swipeable}
                  index={i}
                  sliderID={sliderID}
                  dragging={dragging}
                  swipeDirection={swipeDirection}
                  sliderLength = {productsInfo.length}
                />
              )
            case "Category":
              return (
                <CategortTile
                  info={pInfo}
                  key={pInfo.sku}
                  sku={pInfo.sku}
                  bgImage={bgImage}
                  headerColor={headerColor}
                  largeTile={largeTile}
                  swipeable={swipeable}
                  index={i}
                  sliderID={sliderID}
                  dragging={dragging}
                  swipeDirection={swipeDirection}
                  sliderLength = {productsInfo.length}
                />
              )
            default:
              return null;}
        }))
      : (whiteTiles = null);
  }
const handleBeforeChange = () => {
  swipeable && setDragging(true)
}
const handleAfterChange = () => {
  swipeable && setDragging(false)
}

const handlers = useSwipeable({
  onSwipedLeft: () => handleSwipeLeft(),
  onSwipedRight: () => handleSwipeRight(),
})
const handleSwipeLeft = () => {
  setSwipeDirection('Left')
}
const handleSwipeRight = () => {
  setSwipeDirection('Right')
}
  return (
    <div
      className={`whiteTiles_slider marg-bottom-20 ${
        !showArrows ? "noArrows" : ""
      }`} {...handlers}>
      {productsInfo && productsInfo !== undefined ? (
        <Carousel
          beforeChange={handleBeforeChange}
          afterChange={handleAfterChange}
          arrows={true}
          customRightArrow={<CustomRightArrow />}
          customLeftArrow={<CustomLeftArrow />}
          swipeable={true}
          draggable={true}
          showDots={true}
          responsive={responsiveWhiteTile}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          partialVisible={true}
          autoPlay={autoplay}
          autoPlaySpeed={autoPlaySpeed}
          keyBoardControl={true}
          customTransition="transform 400ms ease-in-out"
          transitionDuration={800}
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
          customDot={<CustomDot/>}
          focusOnSelect={false}
          preventDefaultTouchmoveEvent={true}
        >
          {whiteTiles}
        </Carousel>
      ) : null}
    </div>
  );
};

export default WhiteTilesSlier;
